import React from "react";
import { Flex, Image, Link, Text, useColorModeValue } from "@chakra-ui/react";

function UserActivation() {
    const textColor = useColorModeValue("secondaryGray.900", "white");
    const brandColor = useColorModeValue("brand.500", "brand.400");

    return (
        <Flex direction="column" align="center" pt={{ sm: "125px", lg: "75px" }}>
            <Image
                src='./account_activated.webp'
                w="400px"
                maxW="90%"
                mt={{ base: "4vh", lg: "15vh" }}
                mb="20px"
                alt="Account Activated Successfully"
            />
            <Text
                color={textColor}
                fontSize={{ base: "36px", lg: "42px" }}
                fontWeight="700"
                mb="20px"
                textAlign="center"
            >
                Congratulations! Your Account is Activated.
            </Text>
            <Text
                color={textColor}
                fontSize={{ base: "md", lg: "lg" }}
                fontWeight="500"
                mb="30px"
                textAlign="center"
                maxW="600px"
            >
                Your account has been successfully activated. You can now sign in to access your account and explore all our features. Click the link below to sign in.
            </Text>
        </Flex>
    );
}

export default UserActivation;
